import { type ReactElement } from 'react';

interface Props {
  align: 'start' | 'center' | 'end';
  children: ReactElement;
}

export const AlignedCell = (props: Props): ReactElement => {
  const { align = 'start', children } = props;

  return <div className={`flex w-full justify-${align}`}>{children}</div>;
};
